import { addDays, formatLongDate, fromIsoDate, isSameDay, toIsoDate } from '@/lib/dates';

type Props = {
  value: string; // ISO YYYY-MM-DD
  onChange: (iso: string) => void;
};

export default function DatePicker({ value, onChange }: Props) {
  const current = fromIsoDate(value);
  const today = new Date();
  const isToday = isSameDay(current, today);

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => onChange(toIsoDate(addDays(current, -1)))}
        className="btn btn-secondary btn-sm"
        aria-label="Jour précédent"
        title="Jour précédent"
      >
        ‹
      </button>

      <div className="px-3 py-1 text-sm font-medium text-text-primary min-w-[200px] text-center">
        {formatLongDate(current)}
      </div>

      <button
        type="button"
        onClick={() => onChange(toIsoDate(addDays(current, 1)))}
        className="btn btn-secondary btn-sm"
        aria-label="Jour suivant"
        title="Jour suivant"
      >
        ›
      </button>

      <button
        type="button"
        onClick={() => onChange(toIsoDate(today))}
        disabled={isToday}
        className="btn btn-secondary btn-sm"
        title="Aller à aujourd'hui"
      >
        Aujourd'hui
      </button>

      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 px-2 text-sm border border-border-medium rounded-md bg-surface-white focus:outline-none focus:border-ktm-orange"
        aria-label="Sélectionner une date"
      />
    </div>
  );
}
